import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import Loadable from "../Loadable";
import { jsx as _jsx } from "react/jsx-runtime";
var LazyTour = function LazyTour(props) {
  return /*#__PURE__*/_jsx(Loadable, _objectSpread({
    module: function module() {
      return import(/* webpackChunkName: "tour" */"./Tour");
    }
  }, props));
};
export default LazyTour;